import { format } from 'date-fns';
import { Input } from '../../ui/input';
import { Dialog, DialogContent } from '../../ui/dialog';
import { Pagination, PaginationContent, PaginationItem, PaginationLink, PaginationPrevious, PaginationNext } from '../../ui/pagination';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';

import { connect } from 'react-redux';
import Select from 'src/components/ui/BrandSelect';
import { Actions as ADMINACTIONS, toggleModal } from '../../../store/actions/adminActions';
import { Button } from '../../ui/button';
import { Calendar, Loader2 } from 'lucide-react';
import Breadcrumb from '../../Common/Breadcrumb';
import BulkEditModal from '../../Modals/BulkEditModal';
import AddEditUsage from '../../UsageData/AddEditUsage';
import { itemToOptions, parseDateToTz } from '../../utils/GlobalFunctions';
import { adminPortalSelect } from '../../utils/ReactSelectStyles';
import UsageDataListTable from './UsageDataListTable';

const items = [{ label: 'Usage Data', link: '/admin/usageData' }];

const divStyle = {
  display: 'flex',
  width: '-webkit-fill-available',
  margin: '0px 10px 10px 10px',
  justifyContent: 'space-between',
  alignItems: 'baseline',
};

const UsageDataList = ({
  getAllItemsFromDB,
  bulkEditModal,
  itemCount,
  branding,
  filterSize,
  options,
  getItemsByTermsFromIndex,
  getItemsByTermsFromIndexExport,
  allFacilities,
  adminPortalModal,
  confirmationModal,
  openSearchTerms,
  usageEditModal,
}) => {
  const { headers } = branding?.fonts?.[0]?.font || {};

  const [page, setPage] = useState(1);
  const [tableSize, setTableSize] = useState(filterSize ? filterSize?.[0] : null);
  const [totalItems, setTotalItems] = useState(null);
  const [filter, setFilter] = useState({});
  const [showHide, setShowHide] = useState(false);
  const [showPagination, setShowPagination] = useState(false);
  const [exporting, setExporting] = useState(false);

  const tableName = 'usageData';

  const handlePageChange = (_, value) => {
    setPage(value);
    getItemsByTermsFromIndex(tableName, filter, value, tableSize?.value);
  };

  const handleTableSizeChange = (selected) => {
    setTableSize(selected);
    setPage(1);
    getItemsByTermsFromIndex(tableName, filter, 1, selected?.value);
  };

  const exportData = async () => {
    setExporting(true);
    const newFilter = { ...filter };
    const filterName = 'generateExport';
    newFilter[filterName] = true;
    await getItemsByTermsFromIndexExport(tableName, newFilter, page, tableSize?.value);
    setExporting(false);
  };

  const handleFilter = (selectedFilter, e) => {
    const newFilter = { ...filter };
    const filterName = e?.target?.name || e.name;

    if (e?.action === 'clear' || !selectedFilter || e?.target?.value === '') {
      delete newFilter[filterName];
    } else if (e?.target?.type === 'text') {
      newFilter[filterName] = e?.target?.value;
    } else if (typeof selectedFilter.getMonth === 'function') {
      const objProp = Object.getOwnPropertyNames(e);
      newFilter[objProp[0]] = { ...newFilter[objProp[0]], ...e[objProp[0]] };
    } else {
      newFilter[filterName] = selectedFilter?.value || selectedFilter;
    }
    setFilter(newFilter);
  };

  const total = totalItems ? totalItems : itemCount;
  useEffect(() => {
    //if (openSearchTerms?.filters && openSearchTerms?.index == tableName) setFilter({ ...openSearchTerms.filters });

    if (!allFacilities) getAllItemsFromDB('facilities');
    if (showHide) setShowPagination(true);
  }, [showHide, page, tableSize, adminPortalModal, confirmationModal, bulkEditModal, allFacilities, getAllItemsFromDB]);

  return (
    <React.Fragment>
      <div className='flex flex-row justify-between'>
        <Breadcrumb items={items} />
      </div>

      {!showHide && (
        <section className='panel' style={{ fontFamily: headers }}>
          <header
            className='panel-heading'
            style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
            Usage Data Filters
          </header>
          <div className='panel-body' style={{ height: 'auto' }}>
            {Object.keys(options)?.map((optionType, index) => {
              if (options[optionType] === 'SearchByText') {
                return (
                  <div key={index} style={divStyle}>
                    <label style={{ fontSize: 16, marginBottom: 0 }}>
                      {optionType.charAt(0).toUpperCase() + optionType.slice(1)}
                    </label>
                    <div style={{ width: '80%' }}>
                      <Input
                        id='outlined-basic'
                        onChange={(e) => handleFilter('id', e)}
                        placeholder='Search By Id'
                        name='id'
                        className='w-full'
                      />
                    </div>
                  </div>
                );
              } else if (options[optionType] === 'DatePicker') {
                return (
                  <div key={index} style={divStyle}>
                    <label style={{ fontSize: 16, marginBottom: 0 }}>
                      {optionType.charAt(0).toUpperCase() + optionType.slice(1)}
                    </label>
                    <div style={{ width: '80%', display: 'flex', justifyContent: 'space-between', zIndex: 0 }}>
                      <div style={{ width: '40%' }}>
                        <label className='input-group date datepicker'>
                          <DatePicker
                            showMonthDropdown
                            name={options?.[optionType]}
                            showYearDropdown
                            yearDropdownItemNumber={5}
                            scrollableYearDropdown
                            dateFormat='dd/MM/yyyy'
                            className='h-9 w-full rounded-lg border border-input bg-transparent px-3 py-2 text-sm startDate'
                            popperPlacement='bottom-end'
                            maxDate={new Date()}
                            selected={
                              (filter?.[optionType]?.['gte'] &&
                                parseDateToTz(filter?.[optionType]?.['gte'], 'yyyy-MM-dd')) ||
                              null
                            }
                            isClearable={true}
                            placeholderText='From'
                            onChange={(date) => {
                              if (!date) handleFilter(null, { name: optionType });
                              else handleFilter(date, { [optionType]: { gte: format(date, 'yyyy-MM-dd') } });
                            }}
                            popperModifiers={{ offset: { enabled: true, offset: '77px, 0px' } }}
                          />
                          <span className='input-group-btn'>
                            <Button variant='ghost' size='sm' className='date-set'>
                              <Calendar size={16} strokeWidth={1.5} />
                            </Button>
                          </span>
                        </label>
                      </div>
                      <div style={{ width: '40%' }}>
                        <label className='input-group date datepicker'>
                          <DatePicker
                            showMonthDropdown
                            showYearDropdown
                            scrollableYearDropdown
                            dateFormat='dd/MM/yyyy'
                            className='h-9 w-full rounded-lg border border-input bg-transparent px-3 py-2 text-sm startDate'
                            popperPlacement='bottom-end'
                            yearDropdownItemNumber={5}
                            isClearable={true}
                            maxDate={new Date()}
                            selected={
                              (filter?.[optionType]?.['lte'] &&
                                parseDateToTz(filter?.[optionType]?.['lte'], 'yyyy-MM-dd')) ||
                              null
                            }
                            placeholderText='To'
                            onChange={(date) => {
                              if (!date) handleFilter(null, { name: optionType });
                              else handleFilter(date, { [optionType]: { lte: format(date, 'yyyy-MM-dd') } });
                            }}
                            popperModifiers={{ offset: { enabled: true, offset: '77px, 0px' } }}
                          />
                          <span className='input-group-btn'>
                            <Button variant='ghost' size='sm' className='date-set'>
                              <Calendar size={16} strokeWidth={1.5} />
                            </Button>
                          </span>
                        </label>
                      </div>
                    </div>
                  </div>
                );
              } else {
                return (
                  <div key={index} style={divStyle}>
                    <label style={{ fontSize: 16, marginBottom: 0 }}>
                      {optionType.charAt(0).toUpperCase() + optionType.slice(1)}
                    </label>
                    <div style={{ width: '80%' }}>
                      <Select
                        id={'select-' + optionType}
                        options={options?.[optionType]}
                        name={optionType}
                        style={adminPortalSelect}
                        onChange={(selected, e) => handleFilter(selected, e)}
                        isClearable={true}
                      />
                    </div>
                  </div>
                );
              }
            })}
            <div
              style={{
                display: 'flex',
                placeItems: 'center',
                alignItems: 'center',
                justifyContent: 'space-evenly',
                marginTop: 20,
              }}>
              <Button
                id='search-btn'
                onClick={() => {
                  getItemsByTermsFromIndex(tableName, filter, page, tableSize?.value);
                  setShowHide(true);
                }}
                disabled={_.isEmpty(filter)}
                style={{ width: '20vh', fontSize: 16 }}>
                Search
              </Button>
              <Button
                id='export-btn'
                onClick={() => {
                  exportData();
                }}
                disabled={_.isEmpty(filter) || exporting}
                style={{ width: '20vh', fontSize: 16 }}>
                {exporting && <Loader2 size={16} strokeWidth={1.5} className="animate-spin" />} Export
              </Button>
            </div>
          </div>
        </section>
      )}

      {showHide && (
        <>
          <UsageDataListTable
            page={page}
            setTableSize={setTableSize}
            tableSize={tableSize}
            setTotalItems={setTotalItems}
            setShowHide={setShowHide}
            handleTableSizeChange={handleTableSizeChange}
            setFilter={setFilter}
            filter={filter}
            setPage={setPage}
            options={options}
            setShowPagination={setShowPagination}
          />

          {total > 0 && showPagination && (() => {
            const pageCount = Math.ceil(total / tableSize?.value);
            return (
              <Pagination>
                <PaginationContent>
                  <PaginationItem>
                    <PaginationPrevious onClick={() => page > 1 && handlePageChange(null, page - 1)} />
                  </PaginationItem>
                  {Array.from({ length: pageCount }, (_, i) => i + 1)
                    .filter((p) => p === 1 || p === pageCount || Math.abs(p - page) <= 2)
                    .map((p, idx, arr) => (
                      <React.Fragment key={p}>
                        {idx > 0 && arr[idx - 1] < p - 1 && <PaginationItem><span className='px-2'>...</span></PaginationItem>}
                        <PaginationItem>
                          <PaginationLink isActive={p === page} onClick={() => handlePageChange(null, p)}>{p}</PaginationLink>
                        </PaginationItem>
                      </React.Fragment>
                    ))}
                  <PaginationItem>
                    <PaginationNext onClick={() => page < pageCount && handlePageChange(null, page + 1)} />
                  </PaginationItem>
                </PaginationContent>
              </Pagination>
            );
          })()}
        </>
      )}

      <Dialog open={!!bulkEditModal} onOpenChange={(open) => !open && toggleModal()}>
        <DialogContent>
          <BulkEditModal bulkType={tableName} options={options} />
        </DialogContent>
      </Dialog>

      {usageEditModal && <AddEditUsage />}
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  const options = {};
  const optionTypes = state?.metric?.types;
  const subentities = state?.subentities;
  const entities = state?.entities;
  const metrics = state?.metric?.list;
  const organisations = state?.admin?.organisations;
  const facilities = state?.admin?.adminPortal?.facilities;
  options.id = 'SearchByText';
  options.entity = entities
    ?.concat({ name: '<null>', id: 'NA' })
    ?.map(itemToOptions)
    ?.sort((a, b) => a.label.localeCompare(b.label));
  options.subentity = subentities
    ?.concat({ name: '<null>', id: 'NA' })
    ?.map(itemToOptions)
    ?.sort((a, b) => a.label.localeCompare(b.label));

  optionTypes &&
    Object.keys(optionTypes)?.map((item) => {
      options[item] = optionTypes[item]
        ?.concat({ name: '<null>', id: 'NA' })
        ?.map(itemToOptions)
        ?.sort((a, b) => a.label.localeCompare(b.label));
      return options;
    });

  options.metric = metrics
    ?.concat({ name: '<null>', id: 'NA' })
    ?.map(itemToOptions)
    ?.sort((a, b) => a.label.localeCompare(b.label));
  options.organisation = organisations
    ?.concat({ name: '<null>', id: 'NA' })
    ?.map(itemToOptions)
    ?.sort((a, b) => a?.label?.localeCompare(b?.label));
  options.facility = facilities
    ?.concat({ name: '<null>', id: 'NA' })
    ?.map(itemToOptions)
    ?.sort((a, b) => a.label.localeCompare(b.label));
  options.dateStart = 'DatePicker';
  options.dateEnd = 'DatePicker';

  return {
    branding: state?.branding,
    itemCount: state?.admin?.termsItems?.totalCount,
    filterSize: state?.admin?.filterSize,
    options,
    termItems: state?.admin?.termsItems?.items,
    allFacilities: facilities,
    adminPortalModal: state.admin?.modal?.adminPortalModal,
    confirmationModal: state.admin?.modal?.confirmationModal,
    bulkEditModal: state?.admin?.modal?.bulkEditModal,
    usageEditModal: state?.usageDataModal?.status,
    openSearchTerms: state?.admin?.openSearchTerms,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getAllItemsFromDB: (table) => dispatch(ADMINACTIONS.getAllItemsFromDB(table)),
  getItemsByTermsFromIndex: (index, filters, page, size) =>
    dispatch(ADMINACTIONS.getItemsByTermsFromIndex(index, filters, page, size)),
  getItemsByTermsFromIndexExport: (index, filters, page, size) =>
    dispatch(ADMINACTIONS.getItemsByTermsFromIndexExport(index, filters, page, size)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UsageDataList);
